import { EMPTY_ARRAY } from '@/global/config'
import { GlobalStorage } from '@/global/storage'
import { fileFile } from '@/modules/goodsdetailmodules/uploadfiles'
import { InquiryQuotationListItem } from '../../reducer'

export type FileItem = {
  name: string
  url: string
}
/**
 * 转换附件列表为json
 */
export function convertAttatchmentList(files: fileFile[] = EMPTY_ARRAY) {
  const attachmentList = files?.map((item) => {
    return {
      name: item.name,
      url: item.url,
    }
  })
  const attachmentListStr = JSON.stringify(attachmentList)
  return attachmentListStr
}
/**
 * 解析附件列表JSON字符串
 * @param attachment JSON字符串
 * @returns 解析后的附件列表
 */
export const parseAttachmentList = (attachment?: string): FileItem[] => {
  if (!attachment) {
    return []
  }
  const ossPath = GlobalStorage.getStorageSync('BASEURL')
  try {
    if (attachment && typeof attachment === 'string') {
      const res = JSON.parse(attachment) || []
      return res.map((item: FileItem) => ({
        name: item.name,
        url: item.url,
        baseUrl: ossPath,
        filename: item.name,
        newFilePath: item.url,
      }))
    }
    return []
  } catch (error) {
    console.warn('解析附件列表失败:', error)
    return []
  }
}

export type FormFields = Pick<
  InquiryQuotationListItem,
  | 'supplierName'
  | 'contactPerson'
  | 'contactPhone'
  | 'contactEmail'
  | 'supplierAddress'
  //   | 'validUntil'
  //   | 'attachment'
> & {
  attachmentList?: any[]
  // 新增：商品明细编辑值
  quotationOrderItemParamList?: Array<{
    unitPrice?: number
    quoteProductCode?: string
    quoteProductBrand?: string
    quoteProductName?: string
    quoteProductSpec?: string
    quoteUnit?: string
    deliveryPeriod?: string
    includeFreight?: number
    configDetail?: string
    remark?: string
    attachment?: string
  }>
}
import { EMPTY_ARRAY } from '@/global/config'
import { GlobalStorage } from '@/global/storage'
import { fileFile } from '@/modules/goodsdetailmodules/uploadfiles'
import { InquiryQuotationListItem } from '../../reducer'

export type FileItem = {
  name: string
  url: string
}
/**
 * 转换附件列表为json
 */
export function convertAttatchmentList(files: fileFile[] = EMPTY_ARRAY) {
  const attachmentList = files?.map((item) => {
    return {
      name: item.name,
      url: item.url,
    }
  })
  const attachmentListStr = JSON.stringify(attachmentList)
  return attachmentListStr
}
/**
 * 解析附件列表JSON字符串
 * @param attachment JSON字符串
 * @returns 解析后的附件列表
 */
export const parseAttachmentList = (attachment?: string): FileItem[] => {
  if (!attachment) {
    return []
  }
  const ossPath = GlobalStorage.getStorageSync('BASEURL')
  try {
    if (attachment && typeof attachment === 'string') {
      const res = JSON.parse(attachment) || []
      return res.map((item: FileItem) => ({
        name: item.name,
        url: item.url,
        baseUrl: ossPath,
        filename: item.name,
        newFilePath: item.url,
      }))
    }
    return []
  } catch (error) {
    console.warn('解析附件列表失败:', error)
    return []
  }
}

export type FormFields = Pick<
  InquiryQuotationListItem,
  | 'supplierName'
  | 'contactPerson'
  | 'contactPhone'
  | 'contactEmail'
  | 'supplierAddress'
  //   | 'validUntil'
  //   | 'attachment'
> & {
  attachmentList?: any[]
  // 新增：商品明细编辑值
  quotationOrderItemParamList?: Array<{
    unitPrice?: number
    quoteProductCode?: string
    quoteProductBrand?: string
    quoteProductName?: string
    quoteProductSpec?: string
    quoteUnit?: string
    deliveryPeriod?: string
    includeFreight?: number
    configDetail?: string
    remark?: string
    attachment?: string
  }>
}
